module.exports = __webpack_public_path__ + "img/eruvaka_icon.e71d76c0.png";